import {
  CREATE_EMPLOYER_START,
  CREATE_EMPLOYER_SUCCESS,
  CREATE_EMPLOYER_ERROR,
  CREATE_CANDIDATE_START,
  CREATE_CANDIDATE_SUCCESS,
  CREATE_CANDIDATE_ERROR,
  UPDATE_CANDIDATE_START,
  UPDATE_CANDIDATE_SUCCESS,
  UPDATE_CANDIDATE_ERROR,
  GET_USER_START,
  GET_USER_SUCCESS,
  GET_USER_STATS_SUCCESS,
  GET_USER_ERROR,
  GET_EMAIL_TYPES_SUCCESS,
  GET_EMAIL_TYPES_OPTIONS_SUCCESS,
  UPLOAD_RESUME_SUCCESS,
  SET_MEMBER,
  SET_USER_STATUS_LIST,
  SHOW_TOAST,
  GET_ADMIN_MEMBERS_START,
  GET_ADMIN_MEMBERS_SUCCESS,
  GET_ADMIN_MEMBERS_CSV_SUCCESS,
  GET_ADMIN_MEMBERS_ERROR
} from "../actions/user.actions";

const INITIAL_STATE = {
  error: null,
  data: {},
  stats: {},
  email: {
    types: [],
    options: []
  },
  loading: false,
  member: {},
  userStatusList: [],
  showToast: false,
  adminMembers: [],
  adminMembersCsv: [],
  loadingGetAdminMembers: false
};

export default function(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case CREATE_EMPLOYER_START:
      return { ...state };
    case CREATE_EMPLOYER_SUCCESS:
      return { ...state };
    case CREATE_EMPLOYER_ERROR:
      return { ...state, error: action.error };
    case CREATE_CANDIDATE_START:
      return { ...state };
    case CREATE_CANDIDATE_SUCCESS:
      return { ...state, data: action.data };
    case CREATE_CANDIDATE_ERROR:
      return { ...state, error: action.error };
    case UPDATE_CANDIDATE_START:
      return { ...state, loading: true, showToast: false };
    case UPDATE_CANDIDATE_SUCCESS:
      return { ...state, data: action.data, loading: false, showToast: true };
    case UPDATE_CANDIDATE_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
        showToast: false
      };
    case GET_USER_START:
      return { ...state };
    case GET_USER_SUCCESS:
      return { ...state, data: action.data };
    case GET_USER_STATS_SUCCESS:
      return { ...state, stats: action.data.navbar };
    case GET_USER_ERROR:
      return { ...state, error: action.error };
    case GET_EMAIL_TYPES_SUCCESS:
      return { ...state, email: { ...state.email, types: action.data.data } };
    case GET_EMAIL_TYPES_OPTIONS_SUCCESS:
      return { ...state, email: { ...state.email, options: action.data.data } };
    case UPLOAD_RESUME_SUCCESS:
      return { ...state };
    case SET_MEMBER:
      return { ...state, member: action.member };
    case SHOW_TOAST:
      return { ...state, showToast: action.showToast };
    case SET_USER_STATUS_LIST:
      return { ...state, userStatusList: action.data };
    case GET_ADMIN_MEMBERS_START:
      return { ...state, loadingGetAdminMembers: true };
    case GET_ADMIN_MEMBERS_SUCCESS:
      return {
        ...state,
        adminMembers: action.data,
        loadingGetAdminMembers: false
      };
    case GET_ADMIN_MEMBERS_CSV_SUCCESS:
      return {
        ...state,
        adminMembersCsv: action.data,
        loadingGetAdminMembers: false
      };
    case GET_ADMIN_MEMBERS_ERROR:
      return { ...state, loadingGetAdminMembers: false };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/user.reducer.js